import { render, staticRenderFns } from "./adminSeckill.vue?vue&type=template&id=a1ce2a5a&scoped=true"
import script from "./adminSeckill.vue?vue&type=script&lang=js"
export * from "./adminSeckill.vue?vue&type=script&lang=js"
import style0 from "./adminSeckill.vue?vue&type=style&index=0&id=a1ce2a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ce2a5a",
  null
  
)

export default component.exports